import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { LinkVariants } from '../../../../utils/_enums/link-variants.enum';
import {Link} from '../../../_shared/link/link';
import { Typography } from '../../../_shared/typography/typography';
import styles from './instance-detail-unlockable-file.module.scss';

export interface Props {
    name: string;
    link: string;
}

export const InstanceDetailUnlockableFile: React.FC<Props> = ({
    link,
    name
}) => {
    if (link)
        return (
            <div className={styles['instance-detail-unlockable-file']}>
                <FontAwesomeIcon icon={['fas', 'download']}/>
                <Link
                    href={link}
                    variant={LinkVariants.STANDARD_LINK}
                    target="_blank"
                    className={styles['unlockable-link']}
                >
                    {name}
                </Link>
            </div>
        );

    return (
        <a className={styles['instance-detail-unlockable-file']}>
            <div className={styles['instance-detail-unlockable-file']}>
                <FontAwesomeIcon icon={['fas', 'download']} />
                <Typography>{name}</Typography>
            </div>
        </a>
    );
};
